import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', () => {
  const isDrawerOpen = ref(false)

  function openDrawer() {
    isDrawerOpen.value = true
  }

  function closeDrawer() {
    isDrawerOpen.value = false
  }

  function toggleDrawer() {
    isDrawerOpen.value = !isDrawerOpen.value
  }

  return {
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  }
})
